"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyButton = exports.StickyButtonWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const window_scroll_1 = __importDefault(require("@react-hook/window-scroll"));
exports.StickyButtonWrapper = styled_components_1.default.button `
	padding: 0;
	margin: 0;
	border: 0;
	display: flex;
	position: fixed;
	z-index: ${props => props.theme.zIndex.stickyButton};
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-shadow: 0 0px 0 3px ${props => (0, polished_1.transparentize)(0.8, props.theme.color.gray6)}, 0 4.2px 2.4px rgba(0, 0, 0, 0.004),
		0 10.7px 6.5px rgba(0, 0, 0, 0.015), 0 21.8px 14.3px rgba(0, 0, 0, 0.029), 0 44.9px 31.6px rgba(0, 0, 0, 0.05),
		0 123px 94px rgba(0, 0, 0, 0.09);
	opacity: 0;
	transform: scale(0);
	transition: all 0.2s ease;

	background: ${props => props.theme.color[props.type]};
	color: ${props => (props.type === 'white' ? props.theme.color.brand3 : props.theme.color.white)};

	${props => {
    switch (props.shape) {
        case 'round':
            return (0, styled_components_1.css) `
					width: auto;
					height: 2rem;
					border-radius: 2rem;
					padding: 0.5rem 1rem;
				`;
        case 'circle':
            return (0, styled_components_1.css) `
					width: 3rem;
					height: 3rem;
					border-radius: 50%;
					padding: 0;
				`;
        case 'square':
            return (0, styled_components_1.css) `
					width: auto;
					height: 2rem;
					border-radius: 0;
					padding: 0.5rem 1rem;
				`;
        default:
            return (0, styled_components_1.css) `
					width: auto;
					height: 2rem;
					border-radius: 2rem;
					padding: 0.5rem 1rem;
				`;
    }
}}

	${props => props.isActive &&
    (0, styled_components_1.css) `
			opacity: 1;
			transform: scale(1);
		`};

	${props => {
    switch (props.placement) {
        case 'top-left':
            return (0, styled_components_1.css) `
					top: 0.75rem;
					left: 0.75rem;
				`;
        case 'top-right':
            return (0, styled_components_1.css) `
					top: 0.75rem;
					right: 0.75rem;
				`;
        case 'bottom-left':
            return (0, styled_components_1.css) `
					bottom: 0.75rem;
					left: 0.75rem;
				`;
        case 'bottom-right':
            return (0, styled_components_1.css) `
					bottom: 0.75rem;
					right: 0.75rem;
				`;
        default:
            return (0, styled_components_1.css) `
					bottom: 0.75rem;
					right: 0.75rem;
				`;
    }
}}
`;
const StickyButton = ({ children, type = 'white', isActive, ...otherProps }) => {
    const theme = (0, styled_components_1.useTheme)();
    const topOffset = (0, window_scroll_1.default)();
    return ((0, jsx_runtime_1.jsx)(exports.StickyButtonWrapper, { isActive: isActive !== undefined ? isActive : topOffset > theme.size.headerHeight * 2, 
        // @ts-ignore
        type: type, ...otherProps, children: children }));
};
exports.StickyButton = StickyButton;
